import { Component, OnInit, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Subscription } from 'rxjs';
import { SpinnerService } from '../../utilities/services/spinner.service';

@Component({
  selector: 'scania-spinner',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './scania-spinner.component.html',
  styleUrls: ['./scania-spinner.component.scss']
})
export class ScaniaSpinnerComponent implements OnInit, OnDestroy {
  isVisible = false;
  private subscription?: Subscription;

  constructor(private spinnerService: SpinnerService) {}

  ngOnInit() {
    this.subscription = this.spinnerService.visible$.subscribe(visible => {
      this.isVisible = visible;
    });
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}